/* Raminho — busca preditiva (sugestões ao digitar, estilo Google)
   Anexa um dropdown de sugestões a todo formulário de busca do tema.
   Usa a API nativa da Shopify: /search/suggest.json. Sem dependências. */
(function () {
  'use strict';

  var CSS = '' +
    '.rmx-sug{position:fixed;background:#fff;' +
    'border:1px solid #e6e1d6;border-radius:16px;box-shadow:0 12px 32px rgba(14,34,56,.14);' +
    'overflow:hidden;z-index:9999;display:none;text-align:left}' +
    '.rmx-sug.rmx-aberto{display:block}' +
    '.rmx-sug__item{display:flex;align-items:center;gap:12px;padding:10px 14px;cursor:pointer;' +
    'text-decoration:none;color:#17324d}' +
    '.rmx-sug__item:hover,.rmx-sug__item.rmx-ativo{background:#faf7f0}' +
    '.rmx-sug__img{width:42px;height:42px;border-radius:8px;object-fit:cover;background:#faf7f0;flex:none}' +
    '.rmx-sug__nome{font-size:14px;font-weight:600;color:#0e2238;line-height:1.25}' +
    '.rmx-sug__preco{font-size:13px;color:#58708a;margin-top:2px}' +
    '.rmx-sug__rodape{display:block;padding:11px 14px;font-size:13px;font-weight:600;' +
    'color:#0e2238;background:#faf7f0;border-top:1px solid #e6e1d6;cursor:pointer;text-align:center;' +
    'text-decoration:none}' +
    '.rmx-sug__rodape:hover{background:#f0b323;color:#0e2238}' +
    '.rmx-sug__vazio{padding:14px;font-size:13px;color:#58708a;text-align:center}';

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  function precoBR(p) {
    if (!p) return '';
    var n = parseFloat(String(p).replace(',', '.'));
    if (isNaN(n)) return '';
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }

  function nomeLimpo(t) {
    return String(t || '').split(' — ')[0].split('  ')[0].trim();
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=84';
  }

  function montar(form, input) {
    // O dropdown vive no <body> (position:fixed) e segue a geometria do form:
    // imune a overflow:hidden/clipping de qualquer ancestral (a "pílula" corta).
    var box = document.createElement('div');
    box.className = 'rmx-sug';
    box.setAttribute('role', 'listbox');
    document.body.appendChild(box);

    var aborta = null, timer = null, ativo = -1;

    function posicionar() {
      var r = form.getBoundingClientRect();
      box.style.top = (r.bottom + 8) + 'px';
      box.style.left = r.left + 'px';
      box.style.width = r.width + 'px';
    }

    function fechar() { box.classList.remove('rmx-aberto'); box.innerHTML = ''; ativo = -1; }

    window.addEventListener('scroll', function () {
      if (box.classList.contains('rmx-aberto')) posicionar();
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (box.classList.contains('rmx-aberto')) posicionar();
    });

    function render(produtos, q) {
      posicionar();
      box.innerHTML = '';
      ativo = -1;
      if (!produtos.length) {
        box.innerHTML = '<div class="rmx-sug__vazio">Nenhum produto encontrado para “' +
          q.replace(/</g, '&lt;') + '”</div>';
        box.classList.add('rmx-aberto');
        return;
      }
      produtos.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'rmx-sug__item';
        a.href = p.url;
        var img = thumb((p.featured_image && p.featured_image.url) || p.image || '');
        a.innerHTML = (img ? '<img class="rmx-sug__img" src="' + img + '" alt="">'
                           : '<span class="rmx-sug__img"></span>') +
          '<span><span class="rmx-sug__nome">' + nomeLimpo(p.title).replace(/</g, '&lt;') +
          '</span><br><span class="rmx-sug__preco">' + precoBR(p.price) + '</span></span>';
        a.addEventListener('mousedown', function (e) { e.preventDefault(); window.location.href = p.url; });
        box.appendChild(a);
      });
      var rodape = document.createElement('a');
      rodape.className = 'rmx-sug__rodape';
      rodape.href = '/search?type=product&q=' + encodeURIComponent(q);
      rodape.textContent = 'Ver todos os resultados para “' + q + '”';
      rodape.addEventListener('mousedown', function (e) { e.preventDefault(); form.submit(); });
      box.appendChild(rodape);
      box.classList.add('rmx-aberto');
    }

    function buscar() {
      var q = input.value.trim();
      if (!q) { fechar(); return; }
      if (aborta) aborta.abort();
      aborta = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide',
            { signal: aborta.signal })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var prods = (j.resources && j.resources.results && j.resources.results.products) || [];
          render(prods, q);
        })
        .catch(function () { /* digitação rápida cancela a anterior, ok */ });
    }

    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(buscar, 180);
    });
    input.addEventListener('focus', function () { if (input.value.trim()) buscar(); });
    input.addEventListener('blur', function () { setTimeout(fechar, 180); });
    input.addEventListener('keydown', function (e) {
      var itens = box.querySelectorAll('.rmx-sug__item');
      if (!box.classList.contains('rmx-aberto') || !itens.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        ativo += (e.key === 'ArrowDown' ? 1 : -1);
        if (ativo < 0) ativo = itens.length - 1;
        if (ativo >= itens.length) ativo = 0;
        itens.forEach(function (el, i) { el.classList.toggle('rmx-ativo', i === ativo); });
      } else if (e.key === 'Enter' && ativo >= 0) {
        e.preventDefault();
        window.location.href = itens[ativo].href;
      } else if (e.key === 'Escape') {
        fechar();
      }
    });
  }

  function anexar(form) {
    var input = form.querySelector('input[name="q"]');
    if (input && !form.dataset.rmxSug) {
      form.dataset.rmxSug = '1';
      montar(form, input);
      return input;
    }
    return null;
  }

  function iniciar() {
    document.querySelectorAll('form[action*="/search"]').forEach(anexar);
  }

  // Delegação global: qualquer campo de busca que apareça DEPOIS (drawer,
  // header clonado, seção carregada dinamicamente) ganha o widget na hora
  // em que a pessoa digita — e a primeira letra já mostra sugestão.
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || el.name !== 'q' || !el.closest) return;
    var form = el.closest('form[action*="/search"]');
    if (form && !form.dataset.rmxSug) {
      anexar(form);
      setTimeout(function () {
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }, 0);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  // volta do histórico/bfcache: garante que está anexado
  window.addEventListener('pageshow', iniciar);
})();
